import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalLarge() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation('common');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        {t('MODAL_LARGES.MODAL_LARGE')}
      </Button>

      <Modal className="custom-modal modal-large" show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t('MODAL_LARGES.MODAL_LARGE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('MODAL_LARGES.LOREM_IPSUM')}</p>
          <div className="modal-buttons mt-5 d-flex justify-content-between">
            <button className="btn btn-default">{t('MODAL_LARGES.NO')}</button>
            <button className="btn btn-default">{t('MODAL_LARGES.YES')}</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalLarge;
